import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk for handling the logout process
export const handleLogout = createAsyncThunk('account/logout', async (token, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.post(
      '/api/users/logout',
      {},
      {
        headers: { Authorization: token }
      }
    );
    // You might want to check the response here to ensure the logout was successful
    if (response.data.status === 'success') {
      // If successful, dispatch the logout action
      dispatch(logout());
    } else {
      dispatch(logout()); // I don't know if you want to dispatch the logout action here
      return rejectWithValue(response.data);
    }
  } catch (error) {
    dispatch(logout()); // I don't know if you want to dispatch the logout action here
    return rejectWithValue(error.response.data);
  }
});

// Define the initial state using the initialState object
export const initialState = {
  token: '',
  isLoggedIn: false,
  isInitialized: false,
  user: null,
  subscriptionPlan: null
};

export const accountSlice = createSlice({
  name: 'account', // name of the state slice
  initialState,
  reducers: {
    accountInitialize: (state, action) => {
      const { isLoggedIn, user, token, subscriptionPlan } = action.payload;
      state.isLoggedIn = isLoggedIn;
      state.isInitialized = true;
      state.token = token;
      state.user = user;
      state.subscriptionPlan = subscriptionPlan ?? null;
    },
    login: (state, action) => {
      const { user, subscriptionPlan } = action.payload;
      state.isLoggedIn = true;
      state.user = user;
      state.subscriptionPlan = subscriptionPlan ?? null;
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.token = '';
      state.user = null;
      state.subscriptionPlan = null;
    }
  }
});

export const { accountInitialize, login, logout } = accountSlice.actions;

export default accountSlice.reducer;
